exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item--mini.el-form-item[data-v-5eb6a08f]:not(:nth-child(1)) {\n  margin-bottom: 5px;\n}\n.tbForm .el-form-item--mini.el-form-item[data-v-5eb6a08f] {\n  margin-bottom: 0;\n}\n", ""]);

// exports
